function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 65c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-6.774a8.226 8.226 0 100-16.452 8.226 8.226 0 000 16.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.014 53.498H55.5v-8.781h6.574l-.863-4.764a2 2 0 013.11-2L79.04 48.175a1 1 0 010 1.642l-14.732 10.23a2 2 0 01-3.11-1.995l.816-4.554z",
    fillRule: "nonzero"
  })));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-head-towards.svg";